import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import { TextFlagButton, TextFlagState } from './TextFlagButton'

export const ToolbarTextFlagButton = styled(TextFlagButton)<{ state: TextFlagState }>`
  justify-content: center;
  padding: 0 12px;
  background-color: ${props => (props.state === TextFlagState.Off ? constants.CORE_PRIMARY : undefined)};
  color: ${props => (props.state === TextFlagState.Off ? constants.CORE_PRIMARY_6 : undefined)};
  font-weight: ${constants.FontWeight.SemiBold};
  font-size: 11px;
  white-space: nowrap;

  &[disabled] {
    opacity: 1;
  }
  &:not(:last-of-type) {
    margin-right: 1px;
  }
  &:first-of-type {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  &:last-of-type {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`

export const ArrowContainer = styled('span')`
  width: 12px;
  height: 12px;
  margin-left: 4px;
  margin-bottom: 2px;
`
